import { Box, Button, Divider, Flex, Input, Spinner, VStack } from '@chakra-ui/react';
import { useState } from 'react';
import { Select } from 'chakra-react-select';

import Layout from '../components/Layout';
import { SearchService } from '../services/search.service';
import RequestCard from '../components/RequestCard';

const searchFields = [
  {
    label: 'Nro. de pedido',
    value: 'id',
  },
  {
    label: 'Cliente',
    value: 'client_name',
  },
  {
    label: 'Teléfono',
    value: 'phone_num',
  },
];

function Dashboard() {
  const defaultSearchField = searchFields.find((field) => field.value === 'client_name');

  const [searchField, setSearchField] = useState(defaultSearchField);
  const [searchValue, setSearchValue] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [requests, setRequests] = useState(null);

  const doSearch = (key, value) => {
    key = key || searchField?.value;
    value = value || searchValue;

    if (!key || !value) {
      return;
    }

    (async () => {
      setIsSearching(true);
      setRequests(null);
      try {
        const res = await SearchService.search(key, value);
        setRequests(res.data.orders);
      } finally {
        setIsSearching(false);
      }
    })();
  };

  const onClickedField = (fieldKey, fieldValue) => {
    setSearchField(searchFields.find((field) => field.value === fieldKey));
    setSearchValue(fieldValue);

    doSearch(fieldKey, fieldValue);
  };

  const onKeyPress = (event) => {
    if (event.key === 'Enter') {
      doSearch(searchField?.value, searchValue);
    }
  };

  return (
    <Flex direction='column' h='100%' m='4' mt='8' overflow='hidden'>
      <Flex gap='2' maxW='64em' w='100%'>
        <Box flex='1'>
          <Select
            colorScheme='blue'
            name='searchField'
            options={searchFields}
            placeholder='Buscar por'
            size='sm'
            value={searchField}
            onChange={setSearchField}
          />
        </Box>
        <Input
          flex='3'
          size='sm'
          type='text'
          value={searchValue}
          onChange={(event) => setSearchValue(event.target.value)}
          onKeyDown={onKeyPress}
        />
        <Button
          alignSelf='end'
          flex='.5'
          isLoading={isSearching}
          size='sm'
          type='submit'
          onClick={() => doSearch()}
        >
          Buscar
        </Button>
      </Flex>
      <Divider mb='4' pt='8' />

      <Flex hidden={!isSearching} justify='center' mt='20'>
        <Spinner color='blue.500' emptyColor='gray.200' size='lg' />
      </Flex>

      {!isSearching && requests ? (
        <VStack align='stretch' overflowY='auto'>
          {requests.map((req) => (
            <RequestCard key={req.pedido} request={req} onClickedField={onClickedField} />
          ))}
        </VStack>
      ) : null}
    </Flex>
  );
}
export default function DashboardWithLayout(...props) {
  return (
    <Layout>
      <Dashboard {...props} />
    </Layout>
  );
}
